import React from 'react';
import appTheme from './Theme';

const Footer =  ({ siteTitle }) => {
  const windowGlobal = typeof window !== 'undefined' && window;
  let theme = "light";

  try {
    theme = windowGlobal.localStorage.getItem("neumTheme")
  } catch {
    
  }

  return (
    <footer style={appTheme[theme]} className="footer">
      <div className="footer-belt">
        <div style={appTheme[theme]} className="company-sign">
          &copy; 2020 {siteTitle}
        </div>
      </div>
    </footer>
  )
};

export default Footer;
